module.exports = __webpack_public_path__ + "img/connect-api2.d8e7b1ba.png";